// import {Configurator, DashboardNavbar, Footer, Sidenav,} from "@/widgets/layout";
import {StatisticsCard} from './widgets/statistics-card'
import {BsArrowReturnLeft, BsCalendar2Event, BsGearWideConnected} from "react-icons/bs";
import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React from "react";
import StatisticsChart from "./widgets/statistics-chart";
import PieChart from "./charts/pie_chart";
import StackedChart from "./charts/stacked_chart";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function ServicesDashboard({works, from}) {

  const compare_text = (new_count, pre_count, title) => {
    const count_difference = new_count - pre_count;
    if (count_difference === 0) {
      return 'مشابه ماه گذشته'
    } else if (count_difference > 0) {
      return persianNumberFormat(`${count_difference} ${title} بیشتر از ماه گذشته`)
    } else if (count_difference < 0) {
      return persianNumberFormat(`${Math.abs(count_difference)} ${title} کمتر از ماه گذشته`)
    }
  }
  
  return (
    <div className="w-full mt-8">
      <Card className="pt-8 w-full bg-gray-200">
        <CardHeader floated={true} shadow={false} className="bg-gray-200">
          <div className="mb-8 flex flex-col items-start justify-between md:flex-row">
            <Typography variant="h5" color="blue-gray">سرویس‌های انجام شده</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">

          <div className="grid grid-cols-1 gap-1 mb-8 md:grid-cols-4 xxl:grid-cols-6">
            <StatisticsCard color="gray" title="سرویس‌های انجام شده" value={works.works_count}
                            footer={compare_text(works.works_count, works.pre_works_count, 'سرویس')}
                            icon={<BsArrowReturnLeft size={50}/>}/>
            <StatisticsCard color="gray" title="رزروهای مشاوره انجام شده" value={works.consultations_count}
                            footer={compare_text(works.consultations_count, works.pre_consultations_count, 'مشاوره')}
                            icon={<BsCalendar2Event size={50}/>}/>
            <StatisticsCard color="gray" title="خدمات انجام شده" value={works.services_count}
                            footer={compare_text(works.services_count, works.pre_services_count, 'خدمت')}
                            icon={<BsGearWideConnected size={50}/>}/>
            <StatisticsCard color="gray" title="خدمات جدید" value={works.services_new_count}
              // footer="بیشتر از ماه قبل"
                            icon={<BsGearWideConnected size={50}/>}/>
            <StatisticsCard color="gray" title="خدمات پرداخت شده" value={works.services_payment_count}
              // footer="بیشتر از ماه قبل"
                            icon={<BsGearWideConnected size={50}/>}/>
            <StatisticsCard color="gray" title="خدمات انجام شده" value={works.services_finish_count}
              // footer="بیشتر از ماه قبل"
                            icon={<BsGearWideConnected size={50}/>}/>
          </div>

          <div className="grid grid-cols-1 gap-1 mb-8 md:grid-cols-2 xxl:grid-cols-6">
            {(works.consultations_count > 0 || works.services_count > 0) &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  [works.consultations_count, works.services_count],
                  ['مشاوره', 'خدمات']
                )}
                title="سرویس های انجام شده به تفکیک"
                description="سرویس های انجام شده به تفکیک خدمات و مشاوره"
                footer="آپدیت شده"
              />
            }

            {
              works.consultations_field_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  works.consultations_field_count.count,
                  works.consultations_field_count.title
                )}
                title="سرویس های مشاوره انجام شده به تفکیک"
                description="سرویس های مشاوره انجام شده به تفکیک رشته‌ها"
                footer="آپدیت شده"
              />
            }

            {
              works.consultations_branch_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  works.consultations_branch_count.count,
                  works.consultations_branch_count.title
                )}
                title="سرویس های مشاوره انجام شده به تفکیک"
                description="سرویس های مشاوره انجام شده به تفکیک گرایش‌ها"
                footer="آپدیت شده"
              />
            }

            {
              works.services_field_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  works.services_field_count.count,
                  works.services_field_count.title
                )}
                title="سرویس های خدمات انجام شده به تفکیک"
                description="سرویس های خدمات انجام شده به تفکیک رشته‌ها"
                footer="آپدیت شده"
              />
            }

            {
              works.services_branch_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  works.services_branch_count.count,
                  works.services_branch_count.title
                )}
                title="سرویس های خدمات انجام شده به تفکیک"
                description="سرویس های خدمات انجام شده به تفکیک گرایش‌ها"
                footer="آپدیت شده"
              />
            }

            {
              works.services_status_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  works.services_status_count.count,
                  works.services_status_count.title
                )}
                title="سرویس های خدمات به تفکیک"
                description="سرویس های خدمات به تفکیک وضعیت"
                footer="آپدیت شده"
              />
            }

            {
              works.last_month_product_income_pie.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  works.last_month_product_income_pie.count,
                  works.last_month_product_income_pie.title
                )}
                title={from !== "person" ? "درآمدهای یک ماه گذشته به تفکیک"
                  : "بهای پرداخت شده یک ماه گذشته به تفکیک"}
                description={from !== "person" ? "درآمدهای یک ماه گذشته به تفکیک مشاوره و خدمات" :
                  "بهای پرداخت شده یک ماه گذشته به تفکیک مشاوره و خدمات"}
                footer="آپدیت شده"
              />
            }

            {
              works.last_month_field_income_pie.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  works.last_month_field_income_pie.count,
                  works.last_month_field_income_pie.title
                )}
                title={from !== "person" ? "درآمدهای یک ماه گذشته به تفکیک" :
                  "بهای پرداخت شده یک ماه گذشته به تفکیک"}
                description={from !== "person" ? "درآمدهای یک ماه گذشته به تفکیک رشته‌ها" :
                  "بهای پرداخت شده یک ماه گذشته به تفکیک رشته‌ها"}
                footer="آپدیت شده"
              />
            }

          </div>

          {
            works.last_month_works &&
            <StatisticsChart
              color="#fff"
              chart={StackedChart(
                works,
                "last_month_works",
                "date",
                "type",
                "count"
              )}
              title="سرویس‌های یک ماهه اخیر"
              description="سرویس‌های یک ماهه اخیر به تفکیک مشاوره و خدمات"
              footer="آپدیت شده"
            />
          }

          {
            works.next_week_works &&
            <div className="mt-8">
              <StatisticsChart
                color="#fff"
                chart={StackedChart(
                  works,
                  "next_week_works",
                  "date",
                  "type",
                  "count"
                )}
                title="سرویس‌های هفته آینده"
                description="سرویس‌های هفته آینده به تفکیک مشاوره و خدمات"
                footer="آپدیت شده"
              />
            </div>
          }

          {
            works.last_month_product_income_bar &&
            <div className="mt-8">
              <StatisticsChart
                color="#fff"
                chart={StackedChart(
                  works,
                  "last_month_product_income_bar",
                  "date",
                  "type",
                  "count"
                )}
                title={from !== "person" ? "درآمدهای یک ماه گذشته" :
                  "بهای پرداخت شده یک ماه گذشته"}
                description={from !== "person" ? "درآمدهای یک ماه گذشته به تفکیک مشاوره و خدمات" :
                  "بهای پرداخت شده یک ماه گذشته به تفکیک مشاوره و خدمات"}
                footer="آپدیت شده"
              />
            </div>
          }

          {
            works.last_month_field_income_bar &&
            <div className="mt-8">
              <StatisticsChart
                color="#fff"
                chart={StackedChart(
                  works,
                  "last_month_field_income_bar",
                  "date",
                  "type",
                  "count"
                )}
                title={from !== "person" ? "درآمدهای یک ماه گذشته" :
                  "بهای پرداخت شده یک ماه گذشته"}
                description={from !== "person" ? "درآمدهای یک ماه گذشته به تفکیک رشته‌ها" :
                  "بهای پرداخت شده یک ماه گذشته به تفکیک رشته‌ها"}
                footer="آپدیت شده"
              />
            </div>
          }

        </CardBody>
      </Card>
    </div>
  );
}


export default ServicesDashboard;
